"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
function default_1(base, context) {
    var colors = base.colors, zoom = base.zoom, children = base.children, areas = base.areas, arearanges = base.arearanges, seriesPlotOptions = base.series, bars = base.bars, bullets = base.bullets, candlesticks = base.candlesticks, columns = base.columns, columnranges = base.columnranges, heatmaps = base.heatmaps, lines = base.lines, pies = base.pies, scatters = base.scatters, colorAxis = base.colorAxis, chartType = base.chartType, dateTimeLabelFormats = base.dateTimeLabelFormats, showAxes = base.showAxes, showLegend = base.showLegend, showNavigator = base.showNavigator, showRangeSelector = base.showRangeSelector, showTooltips = base.showTooltips, title = base.title, showScrollbar = base.showScrollbar, chartOptions = __rest(base, ["colors", "zoom", "children", "areas", "arearanges", "series", "bars", "bullets", "candlesticks", "columns", "columnranges", "heatmaps", "lines", "pies", "scatters", "colorAxis", "chartType", "dateTimeLabelFormats", "showAxes", "showLegend", "showNavigator", "showRangeSelector", "showTooltips", "title", "showScrollbar"]);
    var navigator = context.navigator;
    var options = {};
    if (base.chartType !== 'gantt') {
        options.plotOptions = _1.plotOptions(base, context);
    }
    if (base.chartType === 'gantt') {
        options.scrollbar = { enabled: !!navigator };
    }
    options.time = { timezoneOffset: new Date().getTimezoneOffset() };
    options.title = { text: '' };
    options.rangeSelector = { enabled: false }; // disables for highcharts, ineffective for head
    options.colors = _1.chartColors(colors);
    options.chart = __assign(__assign({ zoomType: zoom }, chartOptions), { style: { 'fontFamily': "'Honeywell Sans Web', Arial, Helvetica, sans-serif" } });
    options.colorAxis = __assign(__assign({}, colorAxis), { showInLegend: context.includesHeatmap });
    options.scrollbar = { enabled: showScrollbar };
    return options;
}
exports.default = default_1;
//# sourceMappingURL=baseOptions.js.map